import {endpoints} from './endpoints'
import request from '../../request'

function isOnline() {
  return navigator.onLine
}

function generateLocalId() {
  return `local_${Date.now()}`
}

function saveLocalDraft(data, id = null) {
  const drafts = JSON.parse(localStorage.getItem('pendingDrafts') || '[]')
  const localId = id || generateLocalId()

  const existingIndex = drafts.findIndex(d => d.id === localId)
  const draft = { id: localId, data, savedAt: new Date().toISOString() }

  if (existingIndex >= 0) {
    drafts[existingIndex] = draft
  } else {
    drafts.push(draft)
  }

  localStorage.setItem('pendingDrafts', JSON.stringify(drafts))
  return localId
}

export function create(data) {
  if (!isOnline()) {
    const localId = saveLocalDraft(data)
    return Promise.resolve({ offline: true, draft: { id: localId } })
  }

  return new Promise((resolve, reject) => {
    request({ url: endpoints.create, method: 'post', data })
      .then(response => resolve(response))
      .catch(error => {
        if (!isOnline()) {
          saveLocalDraft(data)
          resolve({ offline: true, message: 'Guardado localmente' })
        } else {
          reject(error)
        }
      })
  })
}

export function update(data) {
  if (!isOnline() || String(data.id).startsWith('local_')) {
    saveLocalDraft(data, data.id)
    return Promise.resolve({ offline: true })
  }

  return new Promise((resolve, reject) => {
    request({ url: endpoints.update, method: 'post', data })
      .then(response => resolve(response))
      .catch(error => {
        if (!isOnline()) {
          saveLocalDraft(data)
          resolve({ offline: true, message: 'Guardado localmente' })
        } else {
          reject(error)
        }
      })
  })
}

export function shareDraft(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.shareDraft,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDraftsByProjectID(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDraftsByProjectID,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getDraftByID(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getDraftByID,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteDraft(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.delete,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function removeUserShared(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.removeUserShared,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}